import { NextApiRequest, NextApiResponse } from 'next'

export async function handlePaymentMethodsMock(
  req: NextApiRequest,
  res: NextApiResponse
) {
  // Always return 403 Forbidden for payment methods
  return res.status(403).json({
    error: 'Forbidden',
    message: 'Access denied to payment methods',
    code: 'PAYMENT_METHODS_ACCESS_DENIED',
  })
}
